import { _colorExp } from "gsap/gsap-core";
import React, { Component } from "react";
import Statsbar from "../../_components/Statsbar/Statsbar";
import "./numbers.css";
class Numbers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      odometerValue: 0,
      didViewCountUp: false,
    };
  }

  render() {
    return (
      <section className="z-50 relative" id="numbers">
        <div
          className="py-16 px-6 md:py-24 z-50"
          style={{
            backgroundImage:
              "url('https://cdn.pmlsound.com/anthem/avm90/images/avm90-numbers-blue-bg.jpg')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
        >
          <div className="max-w-7xl mx-auto z-50">
            <h4 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center text-white leading-snug z-50">
              The numbers speak <br />
              for themselves.
            </h4>

            <div class="place-items-start justify-center grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5 text-white mt-20">
              <div class="text-center w-full lg:px-10 md:px-10 ">
                <h4 className="text-3xl md:text-5xl lg:text-6xl   font-bold">
                  <Statsbar duration={1000} value={32} theme="default" />

                  <span className="text-xs text-gray-400 font-extralight">
                    bit
                  </span>
                  <hr className="mb-2 bg-gray-600 border-0 h-0.5" />

                  <span className="block text-xs text-gray-300 font-bold ">
                    768kHz
                  </span>
                </h4>
                <p className="text-sm text-gray-400 font-light">
                  Digital Analog Converter (DAC)
                </p>
                {/* <p className="text-sm text-gray-400 font-light">
                  Digital to Analogue Converter (DAC)
                </p> */}
              </div>

              <div class="text-center w-full lg:px-6 md:px-6 ">
                <div>
                  <h4 className="text-3xl md:text-5xl inline-block lg:text-6xl  font-bold">
                    <Statsbar duration={1000} value={1.6} theme="default" />
                  </h4>

                  <span className="text-xs text-gray-400 font-extralight ml-0 relative ">
                    Ghz
                  </span>
                  <hr className="mb-2 bg-gray-600 border-0 h-0.5" />

                  <span className="block text-xs text-gray-300 font-bold ">
                    Dual-Core DSP
                  </span>
                </div>
                <p className="text-sm text-gray-400 font-light">
                  With Floating 64-Bit Dual Precision States
                </p>
              </div>
              <div class="text-center w-full lg:px-8 md:px-8 ">
                <h4 className="text-3xl md:text-5xl lg:text-6xl  font-bold">
                  <Statsbar duration={1000} value={7} theme="default" />
                  <span className="text-sm text-gray-400 font-extralight relative -ml-1">
                    in
                  </span>
                  <span className="ml-2 mr-2">/</span>
                  <Statsbar duration={1000} value={3} theme="default" />

                  <span className="text-sm text-gray-400 font-extralight">
                    out
                  </span>
                  <hr className="mb-2 bg-gray-600 border-0 h-0.5" />
                  {/* <span className="block text-xs text-gray-300 font-bold ">
                    up to 48Gbs
                  </span> */}
                </h4>
                <p className="text-sm text-gray-400 font-light">
                  Dedicated HDMI 8K Ports with eARC
                </p>
              </div>

              <div class="text-center w-full lg:px-10 md:px-10 ">
                <h4 className="text-3xl md:text-5xl lg:text-6xl  font-bold">
                  <Statsbar duration={1000} value={19} theme="default" />
                  <hr className="mb-2 bg-gray-600 border-0 h-0.5" />

                  {/* <span className="block text-xs text-gray-300 font-bold invisible ">
                    {"."}
                  </span> */}
                </h4>
                <p className="text-sm text-gray-400 font-light">
                  Channel Count
                </p>
              </div>
              <div class="text-center w-full lg:px-10 md:px-10 ">
                <h4 className="text-3xl md:text-5xl lg:text-6xl  font-bold">
                  <Statsbar duration={1000} value={4} theme="default" />
                  {/* <span className="block text-xs text-gray-300 font-bold invisible ">
                    {"."}
                  </span> */}
                  <hr className="mb-2 bg-gray-600 border-0 h-0.5" />
                </h4>
                <p className="text-sm text-gray-400 font-light">
                  Dedicated Sub Outputs
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default Numbers;
